// AUTO-GENERATED — part 1 of packages/shared/src/index.ts (split-large-files.mjs)
import type {
  Message,
  ToolEvent,
  TodoStatus,
  TodoItem,
  TodoListSnapshot,
} from "./_shared.js";
export function todoListFromToolEvent(
  event: ToolEvent,
): TodoListSnapshot | null {
  if (event.name !== "update_todo_list") return null;
  for (const candidate of [event.result, event.arguments]) {
    if (
      !candidate ||
      typeof candidate !== "object" ||
      !("todos" in candidate) ||
      !Array.isArray(candidate.todos)
    )
      continue;
    const todos = candidate.todos.flatMap((item): TodoItem[] => {
      if (
        !item ||
        typeof item !== "object" ||
        !("content" in item) ||
        !("status" in item)
      )
        return [];
      const content =
        typeof item.content === "string" ? item.content.trim() : "";
      const status = String(item.status);
      if (!content || !["pending", "in_progress", "completed"].includes(status))
        return [];
      return [{ content, status: status as TodoStatus }];
    });
    if (todos.length !== candidate.todos.length || !todos.length) continue;
    const explanation =
      "explanation" in candidate && typeof candidate.explanation === "string"
        ? candidate.explanation.trim()
        : "";
    return {
      todos,
      ...(explanation ? { explanation } : {}),
      completed: todos.filter((todo) => todo.status === "completed").length,
      total: todos.length,
    };
  }
  return null;
}

export function latestTodoList(
  messages: Pick<Message, "toolEvents">[],
): TodoListSnapshot | null {
  for (
    let messageIndex = messages.length - 1;
    messageIndex >= 0;
    messageIndex -= 1
  ) {
    const events = messages[messageIndex].toolEvents ?? [];
    for (let eventIndex = events.length - 1; eventIndex >= 0; eventIndex -= 1) {
      const snapshot = todoListFromToolEvent(events[eventIndex]);
      if (snapshot) return snapshot;
    }
  }
  return null;
}

export type MessageActivityEvent =
  | {
      id: string;
      type: "text";
      content: string;
      contentRange?: { start: number; end: number };
    }
  | { id: string; type: "reasoning"; content: string }
  | { id: string; type: "memory"; added: string[]; forgotten: string[] }
  | { id: string; type: "error"; error: string }
  | {
      id: string;
      type: "compaction";
      status: "started" | "completed" | "failed";
      startedAt: string;
      finishedAt?: string;
      omittedMessages: number;
      summary?: string;
      error?: string;
      providerContext?: { retainedMessages: Record<string, unknown>[] };
    }
  | { id: string; type: "tool"; tool: ToolEvent };

export interface MessageVersion {
  id: string;
  versionGroupId: string;
  versionIndex: number;
  content: string;
  createdAt: string;
  modelId?: string | null;
  modelName?: string | null;
  modelRemoteId?: string | null;
  error?: string | null;
}
